import React from 'react';
import { Section } from '../ui/Section';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section className="bg-dark-800" data-id="element-86">
      <div className="max-w-3xl mx-auto bg-dark-900 border-2 border-gold-500/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-87">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gold-500/5 pointer-events-none" data-id="element-88" />

        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-dark-800 border border-gold-500/50 mb-8 shadow-gold-glow" data-id="element-89">
          <ShieldCheck className="w-10 h-10 text-gold-400" data-id="element-90" />
        </div>

        <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-91">
          GARANTÍA 7 DÍAS
        </h2>

        <div className="space-y-4 text-xl text-gray-300 font-medium" data-id="element-92">
          <p data-id="element-93">Probás todo</p>
          <p data-id="element-94">
            Si no te sirve:{' '}
            <span className="text-gold-400 font-bold" data-id="element-95">
              👉 devolución del 100%
            </span>
          </p>
          <p data-id="element-96">Sin vueltas</p>
        </div>
      </div>
    </Section>;
}